module.exports = __webpack_public_path__ + "img/23.1c9084a9.png";